import {useQuery} from '@tanstack/react-query'

import type {QueryOptions, QueryParams, QueryReturn} from '../types'

import {queries, type Queries} from '@refra/api/queries'

type useRefraQueryProps<K extends keyof Queries, TReturn = QueryReturn<K>> = {
  queryKey: K
  params: QueryParams<K>
} & QueryOptions<K, TReturn>

// Wrapper around useQuery from @tanstack/react-query.
// Should be used as it allows a type safe interface into the available queries that we have defined.
export const useRefraQuery = <K extends keyof Queries, TReturn = QueryReturn<K>>({
  queryKey,
  params,
  ...rest
}: useRefraQueryProps<K, TReturn>) => {
  return useQuery({
    queryKey: [queryKey, ...params],
    // @ts-expect-error for ...params since we are passing params dynamically
    queryFn: async () => queries[queryKey](...params) as Promise<QueryReturn<K>>,
    ...rest
  })
}
